import { Grid } from '@mui/material'
import { CSSProperties } from 'react'
import styled from 'styled-components'
import { mainTheme } from '../../../../styles/mainTheme'

export const RowWrapper = styled(Grid)`
  flex-basis: 0;
`

export const PlaceSectionWrapper = styled(Grid)`
  ${mainTheme.breakpoints.down('md')} {
    margin-top: ${mainTheme.spacing(2.5)}px;
  }
`

export const iconStyle: CSSProperties = {
  width: 24,
  height: 24,
}
